import { takeLatest, put, call, select, all } from 'redux-saga/effects';
import omit from 'lodash/omit';
import isEmpty from 'lodash/isEmpty';
import split from 'lodash/split';
import filter from 'lodash/filter';
import keys from 'lodash/keys';
import get from 'lodash/get';
import find from 'lodash/find';
import { updateShippingGroupsInfo } from 'yoda-interfaces/lib/Order/OrderApi';
import { getCustomerAddresses } from 'yoda-interfaces/lib/Account/AccountApi';
import FactorySaga from 'yoda-site-components/lib/sagas/FactorySaga';
import showGlobalLoader from 'yoda-checkout-components/lib/actions/ShowGlobalLoaderAction';
import { CLEAR_ORDER_ERROR } from 'yoda-checkout-components/lib/actionTypes/ServiceErrorHandlerActionTypes';
import LocalStorage from 'yoda-core-components/lib/helpers/LocalStorage/LocalStorage';
import { URL_REVIEW_PAGE } from 'yoda-checkout-components/lib/common/Constants';
import { handleCartExceptions } from 'yoda-checkout-components/lib/helpers/Utils/Utils';
import { setRemoveRestrictedItemsFlag } from 'yoda-checkout-components/lib/actions/ShippingAddressActions';
import ExceptionHandler from 'yoda-checkout-components/lib/helpers/ExceptionHandler';
import {
    SUBMIT_SHIPPING_ADDRESS_FORM,
    SUBMIT_SHIPPING_ADDRESS_FORM_SUCCESS,
    SUBMIT_SHIPPING_ADDRESS_FORM_FAILURE,
    GET_ADDRESS_LIST,
    IS_SHOWING_SHIPPING_ADDRESS,
    SERVICE_LEVELS_REQUESTED,
    SET_ADDRESS_STANDARDIZATION,
    NO_ACTION,
    ADD_ADDRESSES_TO_ADDRESS_LIST,
    SHOW_HIDE_MILITARY_ADDRESS_FIELDS,
    GET_ADDRESS_LIST_RESPONDED,
    GET_ADDRESS_LIST_GR,
    SET_SELECTED_ADDRESS,
    ADD_ADDRESS_TO_ADDRESS_LIST,
    GENERIC_API_ERROR,
    CLEAR_ADDRESS_LIST,
    CHANGE_ADDRESS_TYPE,
} from '../actionTypes/ShipAndPayActionTypes';
import { submitShippingAddressForm } from '../actions/ShippingAddressFormActions';
import { isOrderIncludeSilverProduct } from '../helpers/ProductTypeUtils/ProductTypeUtils';
import * as CartActionTypes from '../actionTypes/CartActionTypes';
import AddressDetailsModel from '../helpers/AddressDetailsModel';
import { CHANGE_TO_NEXT_ACCORDION } from '../actionTypes/CheckoutActionTypes';
import { validateShipping } from '../actions/CheckoutPageActions';
import ApplicationLogger from '../helpers/ApplicationLogger';
import { DISPLAY_ALT_CHARGES } from '../actionTypes/AlternateChargeActionTypes';
import { GET_ORDER_SHIPPING_GROUPS_INFO } from '../actionTypes/OrderActionTypes';

const errorHandler = {
    context: 'ADDRESS',
    errorComponent: 'ADDRESS_SECTION',
};

export const deliveryDays = (state) => state.deliveryDays;
export const shippingMethods = (state) => state.shippingAddressForm.shippingMethods;
export const defaultAddress = (state) => state.shippingAddressForm.defaultAddress;
export const selectedAddress = (state) => state.shippingAddressForm.selectedAddress;
export const billing = (state) => ((state.orderDetails || {}).data || {}).billing;
const checkoutPage = (state) => state.checkoutPage || {};
const logger = ApplicationLogger.getLogger();
const accountCallStatus = (state) => state.shippingAddressForm.accountCallSucceeded;
const shippingAddresslist = (state) => state.shippingAddressForm.addressList;
function* submitShippingAddress(action) {
    const { shippingAddress } = action;
    if (isEmpty(shippingAddress.id) || !shippingAddress.id) {
        return;
    }
    const payload = {
        payload: {
            params: omit(shippingAddress, [
                'id',
                'continueToReview',
                'getServiceLevels',
                'isSilverItem',
                'isUserLoggedIn',
            ]),
            id: shippingAddress.id,
        },
    };
    if (payload.payload.params.address && payload.payload.params.type === 'STORE') {
        payload.payload.params.pickup = {};
        payload.payload.params.pickup.firstName = payload.payload.params.address.firstName;
        payload.payload.params.pickup.lastName = payload.payload.params.address.lastName;
        payload.payload.params.pickup.phone = payload.payload.params.address.phone;
        delete payload.payload.params.address;
    }
    if (
        payload.payload.params.instructions &&
        isEmpty(payload.payload.params.instructions[0].message)
    ) {
        delete payload.payload.params.instructions;
    }

    if (payload.payload.params.address && !isEmpty(payload.payload.params.address.relationships)) {
        const omittingKeys = filter(
            keys(payload.payload.params.address),
            (key) => key !== 'relationships' && key !== 'secondaryPhone'
        );
        payload.payload.params.address = omit(payload.payload.params.address, omittingKeys);
        payload.payload.params = omit(payload.payload.params, ['id', 'type']);
    }
    let actionAfterSubmit = shippingAddress.continueToReview
        ? { type: NO_ACTION }
        : {
              type: CHANGE_TO_NEXT_ACCORDION,
          };
    const getShippingMethod = { type: SERVICE_LEVELS_REQUESTED, getServiceLevels: false };
    const accountCallSucceeded = yield select(accountCallStatus);
    let addAddressToList =
        shippingAddress.isUserLoggedIn ||
        shippingAddress.type === 'STORE' ||
        (shippingAddress.address &&
            shippingAddress.address.relationships &&
            !isEmpty(shippingAddress.address.relationships.giftRegistry))
            ? { type: NO_ACTION }
            : { type: ADD_ADDRESSES_TO_ADDRESS_LIST, addressList: [shippingAddress] };
    if (
        shippingAddress.isUserLoggedIn &&
        !accountCallSucceeded &&
        shippingAddress.type !== 'STORE' &&
        !(
            shippingAddress.address &&
            shippingAddress.address.relationships &&
            !isEmpty(shippingAddress.address.relationships.giftRegistry)
        )
    ) {
        addAddressToList = { type: ADD_ADDRESS_TO_ADDRESS_LIST, address: shippingAddress };
    }
    actionAfterSubmit = shippingAddress.getServiceLevels ? getShippingMethod : actionAfterSubmit;
    const cartDetailsAction = shippingAddress.getServiceLevels
        ? {
              type: CartActionTypes.CART_DETAILS_GET_REQUEST,
              payload: {
                  includeServiceLevels: true,
              },
          }
        : {
              type: CartActionTypes.CART_DETAILS_GET_REQUEST,
          };
    if (shippingAddress.continueToReview && !shippingAddress.getServiceLevels) {
        const reviewURL = {
            pathname: URL_REVIEW_PAGE,
        };
        cartDetailsAction.payload = {
            nextPage: reviewURL,
        };
    }
    payload.payload.errorHandler = errorHandler;
    const isXStandardizationRequired = LocalStorage.getData('xStandardizationRequired', true);
    if (isXStandardizationRequired) {
        payload.payload.isXStandardizationRequired = isXStandardizationRequired;
    }
    if (shippingAddress.removeRestrictedItems) {
        payload.payload.removeRestrictedItems = shippingAddress.removeRestrictedItems;
    }
    yield put(showGlobalLoader(true));
    const result = yield call(FactorySaga, updateShippingGroupsInfo, payload);
    // Clear shipping related error messages
    yield put({ type: CLEAR_ORDER_ERROR, payload: 'reviewShipping' });
    if (result.isSuccess) {
        // for giftregistry and guest flow if user adds new address clear address list
        const shippAddresList = yield select(shippingAddresslist);
        if (
            shippAddresList &&
            shippAddresList.length === 1 &&
            !shippingAddress.isUserLoggedIn &&
            shippAddresList[0].address &&
            shippAddresList[0].address.relationships &&
            shippAddresList[0].address.relationships.giftRegistry &&
            !isEmpty(shippAddresList[0].address.relationships.giftRegistry.id)
        ) {
            yield put({ type: CLEAR_ADDRESS_LIST });
        }
        LocalStorage.removeData('xStandardizationRequired', true);
        const warningHeader = result.response.headers.get('x-warning');
        if (warningHeader) {
            const warningMessage = split(warningHeader, ',');
            if (warningMessage && warningMessage.length > 0) {
                const warningSplit = warningMessage[0].split('|');
                const errorHandlerInfo = errorHandler;
                errorHandlerInfo.errorCode = warningSplit[0] || GENERIC_API_ERROR;
                // eslint-disable-next-line prefer-destructuring
                errorHandlerInfo.errorMessage = warningSplit[1];
                cartDetailsAction.payload && delete cartDetailsAction.payload.nextPage;
                const oosException = ExceptionHandler.handleOOSException([errorHandlerInfo]);
                if (oosException) {
                    yield put(cartDetailsAction);
                } else {
                    cartDetailsAction.payload
                        ? (cartDetailsAction.payload.errorHandlerInfo = errorHandlerInfo)
                        : (cartDetailsAction.payload = {
                              errorHandlerInfo,
                          });
                    yield put(cartDetailsAction);
                }
            }
        } else {
            yield all([
                put({
                    type: SUBMIT_SHIPPING_ADDRESS_FORM_SUCCESS,
                    submitAddressResponse: result.response,
                }),
                put(actionAfterSubmit),
                put(validateShipping(true)),
                put(cartDetailsAction),
                put(addAddressToList),
                put({
                    type: IS_SHOWING_SHIPPING_ADDRESS,
                    showShippingAddressFields: false,
                }),
                put({
                    type: SHOW_HIDE_MILITARY_ADDRESS_FIELDS,
                    value: false,
                }),
            ]);
            if (shippingAddress.type === 'STORE') {
                yield put({ type: SERVICE_LEVELS_REQUESTED, getServiceLevels: true });
            }
        }
    } else {
        const data = get(result, 'response.data', []);
        handleCartExceptions(data);
        if (
            result &&
            result.response &&
            result.response.data &&
            result.response.data[0] &&
            result.response.data[0].errorCode &&
            result.response.data[0].errorCode.indexOf('SRV_CUSTOMER_STD_CDI') !== -1
        ) {
            LocalStorage.setData('xStandardizationRequired', false, true);
        }
        yield put(showGlobalLoader(false));
        yield all([
            put({
                type: SUBMIT_SHIPPING_ADDRESS_FORM_FAILURE,
                submitAddressResponse: result.response,
            }),
            put({ type: SERVICE_LEVELS_REQUESTED, getServiceLevels: true }),
        ]);
    }
    yield put(setRemoveRestrictedItemsFlag(false));
}

const isLoadedFromReview = (state) => state.checkoutPage.isLoadedFromReview;
const orderItems = (state) => state.orderItems;
const orderShippingGroupInfo = (state) => state.orderShippingGroupsInfo;
const requestServiceLevels = (state) => state.shippingAddressForm.requestServiceLevels;
const displayAFOAddressFields = (state) => state.shippingAddressForm.displayAFOAddressFields;
const getAddressListState = (state) => state.shippingAddressForm.addressList;

const getContext = (state) => state.context;
const getUpdatingAddressId = (state) => state.shippingAddressForm.updatingAddressId;
const getIsAddressAddedOrUpdated = (state) => state.shippingAddressForm.isAddressAddedOrUpdated;
const getInstructions = (state) => state.form.shippingAddressForm.values.instructions;
const getSecondaryPhone = (state) => state.form.shippingAddressForm.values.secondaryPhone;
const getRemoveRestrictedItems = (state) => state.accountAddressData.removeRestrictedItem;
export function* getAddressList(headers) {
    const payload = { payload: { errorHandler }, headers, apiName: 'GET_CUSTOMER_ADDRESSES_API' };
    let updatingAddressId;
    let isAddressAddedOrUpdated;
    let orderShippingGroupsInfo;
    let addressList;
    let getServiceLevels;
    let isSilverItem;
    let loadedFromReview;
    let instructions;
    let secondaryPhone;
    !__SERVER__ && (isAddressAddedOrUpdated = yield select(getIsAddressAddedOrUpdated));
    if (isAddressAddedOrUpdated) {
        updatingAddressId = yield select(getUpdatingAddressId);
        orderShippingGroupsInfo = yield select(orderShippingGroupInfo);
        addressList = yield select(getAddressListState);
        getServiceLevels = yield select(requestServiceLevels);
        isSilverItem = isOrderIncludeSilverProduct(yield select(orderItems));
        loadedFromReview = yield select(isLoadedFromReview);
        instructions = yield select(getInstructions);
        secondaryPhone = yield select(getSecondaryPhone);
    }
    payload.payload.notShipToOtherCountry = true;
    const result = yield call(FactorySaga, getCustomerAddresses, payload, logger);
    yield put(showGlobalLoader(false));
    if (result.isSuccess) {
        const addressDetailsModel = new AddressDetailsModel(result);
        const currentSelectedAddress = yield select(selectedAddress);
        yield all([
            put(addressDetailsModel.addAddressesToAddressList()),
            put(addressDetailsModel.setDefaultAddress(currentSelectedAddress)),
            put({
                type: SET_ADDRESS_STANDARDIZATION,
                isXStandardizationRequired: 'true',
            }),
        ]);
        /* if address is added or updated to account, take the newly changed address from addresslist and submit it to order */
        if (isAddressAddedOrUpdated && !isEmpty(orderShippingGroupsInfo)) {
            let orderShippingGroup = find(
                orderShippingGroupsInfo,
                (group) => group.type === 'HOME'
            );
            !orderShippingGroup &&
                (orderShippingGroup = find(
                    orderShippingGroupsInfo,
                    (group) => group.type === 'STORE'
                ));
            const updatedAddress = addressDetailsModel.getUpdatedAddress(
                updatingAddressId,
                addressList
            );
            if (!isEmpty(updatedAddress)) {
                const address = { ...updatedAddress.address };
                address.instructions = instructions;
                address.secondaryPhone = secondaryPhone;
                const removeRestrictedItems = yield select(getRemoveRestrictedItems);
                yield put({
                    type: SET_SELECTED_ADDRESS,
                    selectedAddress: address,
                });
                yield put(
                    submitShippingAddressForm(
                        address,
                        yield select(displayAFOAddressFields),
                        orderShippingGroup.id,
                        loadedFromReview,
                        getServiceLevels,
                        isSilverItem,
                        true,
                        removeRestrictedItems
                    )
                );
            }
        }
        yield put({ type: GET_ADDRESS_LIST_RESPONDED, getAddressListResponse: result });
    } else {
        yield all([
            put({
                type: SUBMIT_SHIPPING_ADDRESS_FORM_FAILURE,
                submitAddressResponse: result.response,
            }),
            put({ type: GET_ADDRESS_LIST_RESPONDED, getAddressListResponse: result }),
        ]);
    }
}

export function* getAddressListWithGR(headers) {
    const payload = { payload: { errorHandler }, headers, apiName: 'GET_CUSTOMER_ADDRESSES_API' };
    // const isGRCallFailedFlag = yield select(isGRCallFailed);
    payload.payload.notShipToOtherCountry = true;
    const result = yield call(FactorySaga, getCustomerAddresses, payload, logger);
    yield put(showGlobalLoader(false));
    if (result.isSuccess) {
        const addressDetailsModel = new AddressDetailsModel(result);
        yield all([
            put(addressDetailsModel.addAddressesToAddressList()),
            put(addressDetailsModel.setDefaultAddress()),
            put({
                type: SET_ADDRESS_STANDARDIZATION,
                isXStandardizationRequired: 'true',
            }),
        ]);
    } else {
        yield put({
            type: SUBMIT_SHIPPING_ADDRESS_FORM_FAILURE,
            submitAddressResponse: result.response,
        });
    }
}
const getAlternateChargeInfo = (state) => state.alternateChargeInfo;
const getShippingAddressType = (state) => state.shippingAddressForm.shippingAddressType;
const getIsOrderSubmittable = (state) => state.isOrderSubmittable;
function* setDisplayAltCharges(orderShippingGroupsInfo, action) {
    const alternateChargeInfo = (yield select(getAlternateChargeInfo)) || {};
    const checkoutState = yield select(checkoutPage);
    const context = yield select(getContext);
    const enableAlternateCharges = get(context, 'featureFlags.enableAlternateCharges', true);
    const isShippingSection = checkoutState.selectedAccordionIndex === checkoutState.shipping.index;
    const isOrderSubmittable = yield select(getIsOrderSubmittable);
    const checkoutExpNew = true;
    if (
        !isOrderSubmittable &&
        enableAlternateCharges &&
        action &&
        action.addressType &&
        (isShippingSection || checkoutExpNew) &&
        !isEmpty(alternateChargeInfo.altCharges)
    ) {
        const orderShippingGroup = find(
            orderShippingGroupsInfo,
            (group) => group.type === action.addressType
        );
        yield put({
            type: DISPLAY_ALT_CHARGES,
            isDisplayAltCharges: isEmpty(orderShippingGroup),
        });
    } else {
        yield put({
            type: DISPLAY_ALT_CHARGES,
            isDisplayAltCharges: false,
        });
    }
}
export function* handleAddressTypeChange(action) {
    const orderShippingGroupsInfo = yield select(orderShippingGroupInfo);
    yield setDisplayAltCharges(orderShippingGroupsInfo, action);
}

export function* handleShippingGroupInfoChange(action) {
    const addressType = yield select(getShippingAddressType);
    yield setDisplayAltCharges(action.payload, { addressType });
}

const watchGetAddressList = function* watchGetAddressList() {
    yield takeLatest(GET_ADDRESS_LIST, getAddressList);
};
watchGetAddressList.sagaName = 'watchGetAddressList';

const watchGetAddressListWithGR = function* watchGetAddressListWithGR() {
    yield takeLatest(GET_ADDRESS_LIST_GR, getAddressListWithGR);
};
watchGetAddressListWithGR.sagaName = 'watchGetAddressListWithGR';

const watchSubmitShippingAddress = function* watchSubmitShippingAddress() {
    yield takeLatest(SUBMIT_SHIPPING_ADDRESS_FORM, submitShippingAddress);
};
watchSubmitShippingAddress.sagaName = 'watchSubmitShippingAddress';

const watchAddressTypeChange = function* watchAddressTypeChange() {
    yield takeLatest(CHANGE_ADDRESS_TYPE, handleAddressTypeChange);
};
watchAddressTypeChange.sagaName = 'watchAddressTypeChange';

const watchShippingGroupInfoChange = function* watchShippingGroupInfoChange() {
    yield takeLatest(GET_ORDER_SHIPPING_GROUPS_INFO, handleShippingGroupInfoChange);
};
watchShippingGroupInfoChange.sagaName = 'watchShippingGroupInfoChange';

export {
    watchGetAddressList,
    watchGetAddressListWithGR,
    watchSubmitShippingAddress,
    watchAddressTypeChange,
    watchShippingGroupInfoChange,
};
